import React from "react";
import Select from "react-select"

class ModuleFilter extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedOptions: []
        };
        this.commit = this.commit.bind(this);
        this.change = this.change.bind(this);
    }

    commit() {
        this.props.onChange(this.state.selectedOptions);
    }

    change(values) {
        this.setState({selectedOptions: values});
        this.props.onChange(values);
    }

    render() {
        return (
                <div>
                    <Select
                            value={this.state.selectedOptions}
                            isMulti={true}
                            name="colors"
                            options={this.props.moduleOptions}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.change}
                            closeOnSelect={false}
                            placeholder={"Alle"}
                            clearAllText={"Alle entfernen"}
                    />
                </div>
        );
    }
}

export default ModuleFilter;



// WEBPACK FOOTER //
// ./src/admin/components/ModuleFilter.js